export const SHOW_REACTIONS = import.meta.env.VITE_SHOW_REACTIONS === "1";

// Defined cutoff: 2025-08-29 14:30 SGT == 2025-08-29 06:30 UTC
export const REACTIONS_CUTOFF_UTC = "2025-08-29T06:30:00Z";

// VITE_REACTION_EXCLUDE_SECTIONS is a comma-separated list of
// unique section names in env variable to hide reactions for.
// Example: VITE_REACTION_EXCLUDE_SECTIONS=gen-g,youth
export const REACTION_EXCLUDE_SECTIONS: string[] = (
  (import.meta.env.VITE_REACTION_EXCLUDE_SECTIONS as string) || ""
)
  .split(",")
  .map((s) => s.trim().toLowerCase()) // normalize for matching
  .filter(Boolean); // remove empty strings
